import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
} from '@angular/core';

import { TranslationKeyMap } from './insight.i18n';

@Component({
    selector: '[cmpsInsightPersist]',
    templateUrl: './persist.insight.component.html',
})
export class PersistInsightComponent implements OnDestroy {
    @Input() isDefault: boolean;
    @Input() isFavourite: boolean;
    @Input() disallowSetDefault: boolean;
    @Input() disallowSetFavourite: boolean;
    @Output() defaultClick: EventEmitter<boolean>;
    @Output() favouriteClick: EventEmitter<boolean>;

    /** @private */
    _i18n = TranslationKeyMap;

    constructor() {
        this.defaultClick = new EventEmitter();
        this.favouriteClick = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.defaultClick.complete();
        this.favouriteClick.complete();
    }
}
